import { render, staticRenderFns } from "./editarUsuario.vue?vue&type=template&id=2ec8f8cf&scoped=true"
import script from "./editarUsuario.vue?vue&type=script&lang=js"
export * from "./editarUsuario.vue?vue&type=script&lang=js"
import style0 from "./editarUsuario.vue?vue&type=style&index=0&id=2ec8f8cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8f8cf",
  null
  
)

export default component.exports